export type PlanId = 'free' | 'starter' | 'creator' | 'studio';
export type PaidPlanId = Exclude<PlanId, 'free'>;

/** Retail offers remain provisional until configured and validated by the operator. */
export const PLAN_LIMITS = {
  creator: {approvals: true, characters: 25, credits: 120, export: true, monthlyPrice: 49, projects: 15},
  free: {approvals: false, characters: 3, credits: 0, export: false, monthlyPrice: 0, projects: 3},
  starter: {approvals: false, characters: 5, credits: 40, export: false, monthlyPrice: 19, projects: 3},
  studio: {approvals: true, characters: 100, credits: 260, export: true, monthlyPrice: 99, projects: 50}
} as const;

export const isPaidPlan = (value: unknown): value is PaidPlanId =>
  value === 'starter' || value === 'creator' || value === 'studio';
